import { useContext } from 'react'

import { ItemsRemoveConfirmContext } from 'src/providers/items-remove-confirm-provider'

const useItemsRemoveConfirm = () => {
  const { setModalValues: setRemoveConfirm, setIsLoadingModal } =
    useContext(ItemsRemoveConfirmContext)

  return { setRemoveConfirm, setIsLoadingModal }
}

export { useItemsRemoveConfirm }
